import ScrollReveal from '../ScrollReveal';
import useObfuscatedEmail from '@/hooks/useObfuscatedEmail';
import { t } from '@/data/translations';
import type { Lang } from '@/pages/Index';

const Contact = ({ lang }: { lang: Lang }) => {
  const { handleEmailClick } = useObfuscatedEmail();
  const tr = t(lang).contact;
  return (
    <section id="contact" className="py-32 md:py-48 px-6 md:px-12 lg:px-24">
      <div className="max-w-4xl mx-auto text-center">
        <ScrollReveal>
          <div className="section-divider mx-auto mb-16" />
        </ScrollReveal>

        <ScrollReveal delay={100}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-8 text-balance">
            {tr.title}
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={200}>
          <p className="text-lg text-muted-foreground mb-12 max-w-xl mx-auto">{tr.subtitle}</p>
        </ScrollReveal>

        <ScrollReveal delay={300}>
          <a
            href="#"
            onClick={handleEmailClick}
            className="inline-flex items-center gap-3 text-lg font-medium text-primary hover:text-primary/80 transition-colors duration-300 group"
          >
            <span className="link-hover">{tr.cta}</span>
            <svg className="w-5 h-5 arrow-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default Contact;
